import React, { useCallback } from 'react';
import { AttachmentViewModel } from '@common/model/resource/attachment/viewModel';
import { AttachmentType } from '@common/model/resource/attachment/type';
import { ResumeAuthorAge, ResumeAuthorName } from '@cp/entities/resume';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Stack } from '@cp/ds/src/components/stack';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { ResumeCardNew as ResumeCardEntity } from 'src/entities/resume/ui/card/ResumeCardNew';
import { ICatalogItem } from 'src/entities/catalog';
import { AUDIO_PLAYER_MODAL_NAME } from 'src/app/shared/components/modals/audioPlayer/const';
import { useModal } from 'src/shared/modalProvider';
import { useClientProfile } from 'src/entities/client';

// Disable lazy load for first items
const EAGER_LOAD_FOR_IDX = 3;

export const ResumeCardWidgetV2 = ({ data, url, index = 0, ...props }: ICatalogItem) => {
  const theme = useTheme();
  const { openModal } = useModal();
  const handleMediaButtonClick = useCallback(
    (attachment: AttachmentViewModel) => {
      if (attachment.type === AttachmentType.Audio) {
        openModal(AUDIO_PLAYER_MODAL_NAME, { title: 'Аудио-обращение', src: attachment.src, careerId: data.careerId });
      }
    },
    [data.careerId, openModal],
  );
  const clientProfile = useClientProfile();

  const handleTitleLinkClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!clientProfile) {
      e.stopPropagation();
    }
  };
  const permalink = url ? String(url) : undefined;

  return (
    <ResumeCardEntity
      data={data}
      header={
        <Link external={Boolean(permalink)} href={permalink} onClick={handleTitleLinkClick} sx={{ display: 'contents' }} underline={false}>
          <Stack alignItems="flex-end" direction="row" gap={'2px'}>
            <ResumeAuthorName
              author={data?.clientProfile || {}}
              sx={{ fontSize: { xs: '14px', md: '16px' }, lineHeight: 1.1, fontWeight: 500 }}
            />
            <ResumeAuthorAge age={data?.clientProfile?.age} variant="small text bold" />
          </Stack>
        </Link>
      }
      loadPolicy={index <= EAGER_LOAD_FOR_IDX ? 'eager' : 'lazy'}
      onMediaButtonClick={handleMediaButtonClick}
      sx={{ backgroundColor: theme.palette.background.default }}
      {...props}
    />
  );
};
